// What the on-demand course writes beyond the shared product writes (src/product/data.js): a step's
// place in its video and whether it's done, in hub.step_progress (docs/data-model.md 4.7: own rows,
// insert and update while has_access; private.merge_step_progress keeps position_seconds as sent and
// done_at as the member set it). Each upsert sends only the columns it changes, so a saved place
// never clears a tick and a tick never moves the place. Never called while staff view as a member.
import { supabase, must } from '../../lib/supabase.js'

const COLUMNS = 'step_id, position_seconds, done_at'

// Their place in a step's video (Pick your patch's episodes), in whole seconds
export async function saveStepPlace(personId, stepId, seconds) {
  const rows = await supabase.from('step_progress')
    .upsert({ person_id: personId, step_id: stepId, position_seconds: Math.max(0, Math.floor(Number(seconds) || 0)) }, { onConflict: 'person_id,step_id' })
    .select(COLUMNS).then(must)
  return rows?.[0] || null
}

// A step ticked as done, or unticked (done_at back to null; the place stays)
export async function markStep(personId, stepId, done) {
  const rows = await supabase.from('step_progress')
    .upsert({ person_id: personId, step_id: stepId, done_at: done ? new Date().toISOString() : null }, { onConflict: 'person_id,step_id' })
    .select(COLUMNS).then(must)
  return rows?.[0] || null
}

// The page's own rows, with 1 step's saved row in place of the old
export function withStepRow(data, row) {
  if (!row) return data
  return { ...data, stepProgress: [...(data.stepProgress || []).filter(p => p.step_id !== row.step_id), row] }
}
